import { arrayMove } from '@dnd-kit/sortable';

/**
 * Reorder `items` by moving the element whose id === activeId to the
 * index of the element whose id === overId. Returns the same array
 * reference (no-op) when either id is missing or they're identical, so
 * callers can skip a state update.
 */
export function reorderById<T>(
  items: T[],
  activeId: string,
  overId: string,
  getId: (item: T) => string,
): T[] {
  const from = items.findIndex((i) => getId(i) === activeId);
  const to = items.findIndex((i) => getId(i) === overId);
  if (from === -1 || to === -1 || from === to) return items;
  return arrayMove(items, from, to);
}
